import { render } from "./LeftMenu.vue?vue&type=template&id=c72cbe80&scoped=true&ts=true"
import script from "./LeftMenu.vue?vue&type=script&lang=ts"
export * from "./LeftMenu.vue?vue&type=script&lang=ts"

import "./LeftMenu.vue?vue&type=style&index=0&id=c72cbe80&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c72cbe80"]])

export default __exports__